import { axiosConsumer } from "./axiosConsumer";

export const getAllClaimRecords = async (
  page: number,
  per_page: number
): Promise<unknown[]> => {
  const { data } = await axiosConsumer.get(
    `api/v1/claim?page=${page}&per_page=${per_page}`
  );
  return data;
};

export const getClaimById = async (claimId: string): Promise<unknown[]> => {
  const { data } = await axiosConsumer.get(`api/v1/claim/${claimId}`);
  return data;
};

export const searchClaim = async (
  page: number,
  per_page: number,
  search
): Promise<unknown[]> => {
  const { data } = await axiosConsumer.post(
    `api/v1/claim/search-claim?page=${page}&per_page=${per_page}`,
    search
  );
  return data;
};

export const sendEmail = async (
  claimId: string,
  toEmail: string[]
): Promise<unknown[]> => {
  const payload = {
    claimId,
    toEmail,
  };

  const { data } = await axiosConsumer.post(`api/v1/send-email`, payload);

  return data;
};
export const getClaimEmails = async (claimId: string): Promise<any> => {
  const { data } = await axiosConsumer.get(`api/v1/claim/${claimId}/emails`);
  return data;
};
